<template>
  <v-flex class="caption grey--text font-weight-light">{{ brand }}</v-flex>
</template>

<script>
export default {
  props: {
    brand: {
      type: String,
      required: true
    }
  }
};
</script>